import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { NoArea } from "./Styles";

export default function No({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="No."
            value={!value ? document.type.description : value}
          />
        </div>
      ) : (
        <NoArea>
          <Informative
            readonly={true}
            label="No."
            value={!value ? document.docNumber : value}
          />
        </NoArea>
      )}
    </>
  );
}
